import { render, staticRenderFns } from "./SingleIdea.vue?vue&type=template&id=164097fb&scoped=true&"
import script from "./SingleIdea.vue?vue&type=script&lang=js&"
export * from "./SingleIdea.vue?vue&type=script&lang=js&"
import style0 from "./SingleIdea.vue?vue&type=style&index=0&id=164097fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164097fb",
  null
  
)

export default component.exports